import * as ActionTypes from '../actions/index';

const defaultState = {
    brokerFirms: [],
    brokerFirmsFiltered: [],
    brokerPostcodes:[],
    fetching: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ActionTypes.GET_BROKER_FIRMS_POSTCODES:
            return {
                ...state,
                fetching: true
            };
            case ActionTypes.GET_BROKER_FIRMS_POSTCODES_SUCCESS:
            return {
                ...state,
                fetching: false,
                brokerPostcodes: action.payload.body
            };
            case ActionTypes.GET_BROKER_FIRMS_POSTCODES_FAILED:
            return {
                ...state,
                fetching: false
            };
        case ActionTypes.GET_BROKER_FIRMS_WITH_AGENTS:
            return {
                ...state,
                fetching: true
            };
        case ActionTypes.GET_BROKER_FIRMS_WITH_AGENTS_SUCCESS:
            return {
                ...state,
                fetching: false,
                brokerFirms: action.payload.body
            };
        case ActionTypes.REQUEST_BROKER_FIRMS_FILTERED:
            return {
                ...state,
                fetching: true,
            };
        case ActionTypes.RECEIVE_BROKER_FIRMS_FILTERED:
            return {
                ...state,
                fetching: false,
                brokerFirmsFiltered: action.payload
            };
        case ActionTypes.GET_BROKER_FIRMS_WITH_AGENTS_FAILED:
            return {
                ...state,
                fetching: false
            };
        case ActionTypes.GET_BROKER_FIRMS:
            return {
                ...state,
                fetching: true
            };
        case ActionTypes.GET_BROKER_FIRMS_SUCCESS:
            return {
                ...state,
                fetching: false,
                brokerFirms: action.payload.body,
                brokerFirmsFiltered :[]
            };
        case ActionTypes.GET_BROKER_FIRMS_FAILED:
            return {
                ...state,
                fetching: false
            };
        case ActionTypes.LOGOUT:
            return {
                ...defaultState
            };
        default:
            return state
    }
}